import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function Footer() {
  const current = new Date();
  const date = `${current.getFullYear()}`;
  const token = localStorage.getItem("_token");
  return (
  <>
    {token ? 
    <footer>
      <Container fluid>
        <Row>
          <Col sm={12} className="text-center">
            <div className="footer-copy-grp d-md-flex justify-content-between align-items-center py-2">
              <p className="text-muted mb-0">{date} © IT Idol Technologies</p>
              <p className="text-muted mb-0">
                Design & Develop by IT Idol Technologies
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
    : null}
  </>
  );
}

export default Footer;
